export default __webpack_public_path__ + "public/img/no_logo_image.png";